export default __webpack_public_path__ + "static/media/Tunic of the Crawling Chaos.8b25e6ba.jpg";